import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ExpandableList from 'components/application/ExpandableList';
import InfoBanner from 'components/application/InfoBanner';

import DivisionItem from 'components/riskRegister/sharedResourceNotices/components/shared/DivisionItem';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function SingleCategoryMultiDivisionsNonEditable({
  category,
  divisions,
  riskAssessment,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'riskRegister.sharedResourceNotices.components.SingleCategoryMultiDivisionsNonEditable',
  });

  const { t: i18nTRiskRegister } = useTranslation('common', {
    keyPrefix: 'riskRegister',
  });

  return (
    <InfoBanner title={i18nT('title')}>
      {i18nTRiskRegister('riskAssessmentBelongsToCategorySharedWith', {
        categoryName: category.attributes.name,
        interpolation: { escapeValue: false },
        riskAssessmentName: riskAssessment.attributes.name,
      })}
      <ExpandableList
        collection={divisions}
        renderItem={(division) => (
          <li key={division.id}>
            <DivisionItem division={division} scopedCategories={[]} />
          </li>
        )}
      />
    </InfoBanner>
  );
}

SingleCategoryMultiDivisionsNonEditable.propTypes = {
  category: resourceShape('trade').isRequired,
  divisions: PropTypes.arrayOf(resourceShape('company')).isRequired,
  riskAssessment: resourceShape('masterActivity').isRequired,
};
